module.exports = __webpack_public_path__ + "img/fuki01_sp.95f873e1.png";